module.exports = __webpack_public_path__ + "img/20_dice[18].31ba1f56.png";